module.exports = __webpack_public_path__ + "static/media/iphone_12_mini_red.90d4d860.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/custom-products/iphone/iphone_12_mini_red.png
// module id = 2085
// module chunks = 0